<template>
  <div>
    <va-aside-layout :title="asideTitle">
      <base-material-card>
        <template v-slot:heading>
          <div class="display-2">
            {{ titleForm }}
          </div>
        </template>
        <robot-form :id="id" :item="item" @saved="onSaved"></robot-form>
      </base-material-card>
    </va-aside-layout>
    <base-material-card :icon="resource.icon" :title="title">
      <va-list
        ref="list"
        :filters="filters"
        disable-create-redirect
        @action="onAction"
      >
        <va-data-table
          show-expand
          disable-select
          :fields="fields"
          disable-create-redirect
          disable-edit-redirect
          @item-action="onAction"
        >
          <template v-slot:expanded-item="{ item }">
            <ListRobotDepartment
              title="Departamentos Robo"
              :icon="resource.icon"
              :robot_id="item.id"
            ></ListRobotDepartment>
          </template>
        </va-data-table>
      </va-list>
    </base-material-card>
  </div>
</template>

<script>
import ListRobotDepartment from "@/resources/robot_department/List.vue";

export default {
  props: ["resource", "title"],
  components: { ListRobotDepartment },
  data() {
    return {
      filters: [
        "id",
        "name",
        "dns",
        { source: "inspectionHours", type: "number" },
        { source: "horimetre", type: "number" },
        { source: "modelo_id", type: "select" }
      ],
      fields: [
        { source: "id", sortable: true },
        { source: "name", sortable: true },
        { source: "dns", sortable: true },
        { source: "inspectionHours", type: "number", sortable: true },
        { source: "horimetre", type: "number", sortable: true },
        { source: "modelo_id", type: "select", sortable: true }
      ],
      asideTitle: null,
      titleForm: null,
      id: null,
      item: null,
      show: false
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    async onAction({ title, id, item }) {
      this.asideTitle = " ";
      this.titleForm = title;
      this.id = id;

      if (item != null) {
        this.item = item != null ? item : item;
      }
    },
    onSaved() {
      this.asideTitle = null;
      this.$refs.list.fetchData();
    }
  }
};
</script>
